module.exports = __webpack_public_path__ + "img/yuejuan.9f21f572.jpg";